import { StoragesList } from "./StoragesList";
import { StoragesShow } from "./StoragesShow";
import { StoragesCreate } from "./StoragesCreate";
import { StoragesEdit } from "./StoragesEdit";

export const storages = {
  list: StoragesList,
  show: StoragesShow,
  create: StoragesCreate,
  edit: StoragesEdit,
};
